export const NODE_ENV = process.env.NODE_ENV;

export const endpoint = process.env.REACT_APP_API_ENDPOINT || '/api';

export const stripeApiKey = process.env.REACT_APP_STRIPE_API;

export const REACT_APP_DEV_AUTO_LOGIN = process.env.REACT_APP_DEV_AUTO_LOGIN;

// Firebase config
export const REACT_APP_FIREBASE_API_KEY =
  process.env.REACT_APP_FIREBASE_API_KEY || '';
export const REACT_APP_FIREBASE_AUTH_DOMAIN =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '';
export const REACT_APP_FIREBASE_DATABASE_URL =
  process.env.REACT_APP_FIREBASE_DATABASE_URL || '';
export const REACT_APP_FIREBASE_PROJECT_ID =
  process.env.REACT_APP_FIREBASE_PROJECT_ID || '';
export const REACT_APP_FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '';
export const REACT_APP_FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '';

// Analytics
export const REACT_APP_GA_TRACKING_ID_ADMIN =
  process.env.REACT_APP_GA_TRACKING_ID_ADMIN;
